import { getModule as getStoreModule } from 'vuex-module-decorators';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IHighlightSlideData from '@app/types/data/slides/IHighlightSlideData';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import AppStoreModule from '@app/store/modules/AppStoreModule';
import AppModule from '@app/types/base/AppModule';
import { stringOrUndefined } from '@app/functions/helpers';
import AbstractSlideTransform from '@app/transforms/slides/AbstractSlideTransform';
import SingleMediaSlideTransform from './SingleMediaSlideTransform';

/**
 * Transform for 008-HighlightSlide
 */
export default class HighlightSlideTransform extends SingleMediaSlideTransform {
	public viewComponent: string = 'HighlightSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<IHighlightSlideData> {
		const appStore: AppStoreModule = getStoreModule(AppStoreModule);

		const data: IHighlightSlideData = {
			...(await super.transform(slide, presentationSettings)),
			loopVideo: true,
			headline: slide.fields.headline,
			elevation: slide.fields.elevation,
			shareViewSection: slide.fields.shareViewSection === 'special-info' ? 'special-info' : undefined,
			operatingTime: typeof slide.fields.operatingTime === 'object' ? undefined : slide.fields.operatingTime,
			operatingTimes: AbstractSlideTransform.parseObjectWithOperatingTimes(slide),
			price: slide.fields.price,
			priceAnnotation: slide.fields.priceAnnotation,
			badgeText: stringOrUndefined(slide.fields.badgeText)
		};

		if (presentationSettings.showTravelGuideBenefits) {
			data.travelGuideBenefits = this.transformRichtext(slide.fields.travelGuideBenefits, presentationSettings);
		}

		if (appStore.activeAppModule === AppModule.Share) {
			data.copy = this.transformRichtext(slide.fields.copy, presentationSettings);
		}

		return data;
	}
}
